import _ from "lodash"
import useRedux from "../../utils/use_redux"
import * as actions from "../actions"

const useApp = (path, fn, undefinedVal) =>
  useRedux("app", actions, path, fn, undefinedVal)

export default useApp
